import React from "react";

const NotFound = () => <div>Movie</div>;

export default NotFound;